export default function handleFetchApiError(errorOrResponse: Error | Response) {
  if (errorOrResponse instanceof Response) {
    throw new Error(
      `Request rejected with status ${errorOrResponse.status} ${errorOrResponse.statusText}`
    )
  }
  throw errorOrResponse
}
